import { Description } from '@zenterprise-inc/ui';

import LoaderAnimation from '@/assets/img/loader-animation.svg';

const LoadingContent = () => {
  return (
    <div className="flex h-[calc(100vh-100px)] items-center">
      <Description.Guide title={'국세청의 신고서 검토 상태를\n확인하고 있어요'} titleSize="medium" imgChild={<LoaderAnimation width="80" height="80" />} />
    </div>
  );
};

export default LoadingContent;
